/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-nested-switch */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { Typography } from '@/components/Atoms';
import LoadingBalls from '@/components/Common/LoadingBalls';
import styles from './LeaderBoardSection.module.scss';
import LeaderboardTwoSvg from '@/components/Svg/LeaderboardTwoSvg';
import api from '@/api/services/achievements';
import { formatNumberDecimals, numberSeparator } from '@/utils/numberSeparator';
import LeaderBoardModal, { ELeaderBoardTabActiveProps } from './leaderboardModal';
import ItemBoxAssetLeaderboardList from './ItemBoxAssetLeaderboardList';
const gtmPrefix = 'gtm-command_center_inventory_tabs-';

interface LeaderboardData {
  type: string;
  records: Array<any>;
  user_position: number;
}

const initialLeaderboardState: Record<string, LeaderboardData> = {
  recentWinners: { type: 'AchievementWinner', records: [], user_position: -1 },
  topLrtWinners: { type: 'TopLrtUser', records: [], user_position: -1 },
  topActiveUsers: { type: 'TopUser', records: [], user_position: -1 },
};

const LeaderBoardSection = () => {
  const { t } = useTranslate('commandCenter');
  const [leaderBoardTabActive, setLeaderBoardTabActive] = useState<ELeaderBoardTabActiveProps>(ELeaderBoardTabActiveProps.max);
  const [isLoading, setIsLoading] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState(initialLeaderboardState);
  const [showModal, setShowModal] = useState<boolean>(false);

  const onClickInventoryTab = (activeItem) => {
    setLeaderBoardTabActive(activeItem);
  };

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      setIsLoading(true);
      try {
        const {
          data: { leaderboards },
        } = await api.getAllLeaderboards();
        const recentWinners = leaderboards.find((lb) => lb.type === 'AchievementWinner') || initialLeaderboardState.recentWinners;
        const topLrtWinners = leaderboards.find((lb) => lb.type === 'TopLrtUser') || initialLeaderboardState.topLrtWinners;
        const topActiveUsers = leaderboards.find((lb) => lb.type === 'TopUser') || initialLeaderboardState.topActiveUsers;
        setLeaderboardData({ recentWinners, topLrtWinners, topActiveUsers });
      } catch (error) {
        console.error('Failed to fetch leaderboard data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboardData();
  }, []);

  const renderTabContent = () => {
    // Select the correct data based on the active tab
    const { records, user_position } =
      leaderboardData[
        leaderBoardTabActive === ELeaderBoardTabActiveProps.last
          ? 'recentWinners'
          : leaderBoardTabActive === ELeaderBoardTabActiveProps.max
          ? 'topLrtWinners'
          : 'topActiveUsers'
      ];

    return (
      <div className='flex flex-col gap-2 justify-between w-full'>
        <ItemBoxAssetLeaderboardList
          list={records.map(({ leaderboard, position }) => ({
            username: leaderboard.username,
            value:
              leaderBoardTabActive === ELeaderBoardTabActiveProps.max
                ? `${numberSeparator(formatNumberDecimals(leaderboard.total_value || 0))}`
                : leaderBoardTabActive === ELeaderBoardTabActiveProps.most
                ? `${numberSeparator(leaderboard.TotalXp || 0)}`
                : leaderboard.name || '',
            position: position,
            level: leaderboard.Rank || '',
            badgeImg: leaderboard.Badge || '',
            rewardType: leaderBoardTabActive === ELeaderBoardTabActiveProps.max ? 'LRT' : 'XP',
          }))}
          lastCol={
            leaderBoardTabActive === ELeaderBoardTabActiveProps.max || leaderBoardTabActive === ELeaderBoardTabActiveProps.most ? 'Amount' : ''
          }
          isRecent={leaderBoardTabActive === ELeaderBoardTabActiveProps.last}
          myRankData={user_position !== -1 ? records.find((item) => item.position === user_position) : undefined}
        />
      </div>
    );
  };

  return (
    <>
      <LeaderBoardModal isLoading={isLoading} visible={showModal} initTab={leaderBoardTabActive} leaderboardData={leaderboardData} onClose={() => setShowModal(false)} />
      <div className='h-full overflow-hidden flex flex-col' onClick={() => setShowModal(true)}>
        <div className='w-full justify-between flex items-center pb-2'>
          <Typography size='s16ToS12' className='text-[#979797] lg:text-[11px] ' isBold>
            {t('RIGHT_SECTION.specialCommandSectionTop.leaderbord')}
          </Typography>
          <button className='flex items-center' onClick={() => setShowModal(true)}>
            <div className=' z-10 my-1 flex justify-center items-center overflow-hidden rounded-full'>
              <span className='relative flex h-5 w-5'>
                <span
                  className='absolute inline-flex h-full w-full rounded-full bg-[#12DB00] opacity-75 animate-ping '
                  style={{ animationDuration: '2s' }}
                ></span>
                <span className='relative inline-flex rounded-full h-3 w-3 bg-[#12DB00] m-auto'></span>
              </span>
            </div>
            <LeaderboardTwoSvg />
          </button>
        </div>
        <div className='w-full h-[1px] bg-[#4F4F4F]'></div>
        <div className='flex mt-2 sm:gap-2 justify-between text-center'>
          {Object.values(ELeaderBoardTabActiveProps).map((tab) => (
            <Typography
              key={tab}
              // size='s12ToS12'
              className={`flex justify-center items-center w-fit cursor-pointer sm:px-1 transition-all text-[11px] ${
                leaderBoardTabActive === tab ? 'text-[#00d0ab] border-b-[1px] pb-1 border-b-[#00D0AB]' : 'text-[#979797]'
              } hover:text-[#00d0ab] hover:border-b-[1px] hover:border-b-[#00D0AB]`}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                setLeaderBoardTabActive(tab);
              }}
            >
              {tab}
            </Typography>
          ))}
        </div>
        <div className='w-full h-[1px] bg-[#9B9B9B] mt-[1px] mb-1'></div>
        {isLoading ? <LoadingBalls /> : <div className={styles.boxItems}>{renderTabContent()}</div>}
      </div>
    </>
  );
};

export default LeaderBoardSection;
